import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useRouter } from '../../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetUserById } from '../../store/thunk/setGetUserById';
import { setGetLastOperation } from '../../store/thunk/setGetLastOperation';
import EventItem from '../../components/eventItem';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import Navigation from '../../components/navigation';

const handleLoadPagination = ({page, setPage, countPage, dispatch, id}) => {
    if (page <= countPage) {
        dispatch(setGetLastOperation({
            page: page + 1,
            rowsPerPage: 20,
            id
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const Events = () => {
    const router = useRouter();
    const dispatch = useDispatch();
  
    const {id} = router.query;

    const [page, setPage] = React.useState(1);
    const [isShowNavigation, setIsShowNavigation] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetUserById(id))
        dispatch(setGetLastOperation({
            id,
            page: 1,
            rowsPerPage: 20
        }))
    }, [id])

    const view = useSelector(state => state.usersMobile.view);
    const list = useSelector(state => state.usersMobile.last_operation);
   
    return (
        <TemplatePage
            title={`Последние действия (${view.login ? view.login : ''})`}
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage,
                dispatch,
                id
            })}
            handleLoading={() => handleLoading(dispatch)}
        >
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', columnGap: 10}}>
                <span 
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        border: '1px solid #ffce01',
                        cursor: 'pointer',
                        outline: 'none',
                        padding: '5px 0',
                        background: '#ffce01',
                        borderRadius: '12px',
                        color: '#24263e',
                        fontSize: 14,
                        fontWeight: 700
                    }}
                    onClick={() => {
                        setIsShowNavigation(true)
                    }}
                >Дополнительно</span>
            </div>
            {
                list.data.map((item) => <EventItem item={item}/>)
            }
            <Navigation isShowNavigation={isShowNavigation} setIsShowNavigation={setIsShowNavigation} id={id}  profile={view}/>
        </TemplatePage>
    )
}

export default Events;